import { useMemo } from 'react';
import { type IntlShape, useIntl } from 'react-intl';

import { type CoverageResource } from '@/lib/queries/coverage';
import { getTranslation, RESOURCE_DEFS } from '@/lib/types/resourceDefs';

import { PieChart } from './PieChart';

type GraphDataItem = {
  label: string;
  data: [number, number];
};

const getData = (
  resources: CoverageResource[],
  service: string,
  t: IntlShape['formatMessage'],
): GraphDataItem[] => {
  return RESOURCE_DEFS.filter(
    resourceDef => resourceDef.service === service,
  ).map(resourceDef => ({
    label: getTranslation(resourceDef, t, false),
    data: [
      resources.filter(
        r =>
          r.service === service &&
          r.resourceType === resourceDef.resourceType &&
          r.managed,
      ).length,
      resources.filter(
        r =>
          r.service === service &&
          r.resourceType === resourceDef.resourceType &&
          !r.managed,
      ).length,
    ],
  }));
};

interface Props {
  resources: CoverageResource[];
}

export const CoverageCharts = ({ resources }: Props): JSX.Element => {
  const { formatMessage } = useIntl();

  const graphData = useMemo(
    () => getData(resources, 'iam', formatMessage),
    [resources, formatMessage],
  );

  return (
    <div className="flex flex-row flex-wrap justify-center space-x-8">
      {graphData.map(({ label, data }) => (
        <div key={label} className="aspect-square">
          <div className="w-[150px] aspect-square">
            <PieChart data={data} />
          </div>
          <h2 className="text-2xl text-center">{label}</h2>
        </div>
      ))}
    </div>
  );
};
